import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { KYMW4600Model } from '../kymw4600.model';
import { Injectable } from '@angular/core';
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * タググループ一覧登録サービス
 * @export RegistTagGroupListService
 * @class RegistTagGroupListService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class RegistTagGroupListService extends PlessJsonResponderSub<null> {
  model: KYMW4600Model;
  private calbak: () => void;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetTagListService
   */
  private getBody(): PlessRequest {
    const updObj = {
      RegistTagGroups: {
        combination: this.model.registTagGroups.map(_ => ({
          parameter: {
            TagGroupName: _.tagGroupName,
            GroupTagIds: _.tags
              .map(_t => _t.tagId)
              .filter(_t => /^\d{8}$/.test(_t))
              .join(','),
          },
        })),
      },
      DeleteTagGroups: {
        combination: this.model.deleteTagGroups.map(_ => ({
          parameter: {
            TagGroupId: _.tagGroupId,
          },
        })),
      },
      UpdateTagGroups: {
        combination: this.model.updateTagGroups.map(_ => ({
          parameter: {
            TagGroupId: _.tagGroupId,
            GroupTagIds: _.tags
              .map(_t => _t.tagId)
              .filter(_t => /^\d{8}$/.test(_t))
              .join(','),
          },
        })),
      },
    };
    if (updObj.RegistTagGroups.combination.length < 1)
      delete updObj.RegistTagGroups;
    if (updObj.DeleteTagGroups.combination.length < 1)
      delete updObj.DeleteTagGroups;
    if (updObj.UpdateTagGroups.combination.length < 1)
      delete updObj.UpdateTagGroups;
    return new PlessRequest({ update: updObj });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof GetTagListService
   */
  execute(model: KYMW4600Model, f: () => void = null): void {
    this.model = model;
    this.calbak = f;
    if (
      this.model.registTagGroups.length < 1 &&
      this.model.deleteTagGroups.length < 1 &&
      this.model.updateTagGroups.length < 1
    ) {
      if (this.calbak) this.calbak();
      return;
    }
    this.send('registTagGroupList', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @memberof GetTagListService
   */
  success() {
    if (this.calbak) this.calbak();
  }
}
